import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const nextcloud = defineConnector({
  identifier: "nextcloud",
  name: "Nextcloud",
  tagLine: "File sharing and collaboration",
  logo,
  protocol: "http",
  tags: ["documents"],
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.appPassword,
    }),
  steps: [
    {
      title: "Create an app password",
      items: [
        {
          kind: "markdown",
          content:
            "In Nextcloud, go to **Settings → Security → Devices & sessions** and create a new app password.",
        },
      ],
    },
    {
      title: "Enter your Nextcloud details",
      items: [
        {
          kind: "url",
          label: "Nextcloud instance URL",
          required: true,
          placeholder: "https://nextcloud.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Nextcloud server.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "App password",
          required: true,
          target: { kind: "secrets", field: "appPassword" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/ocs/v1.php/cloud/capabilities?format=json`,
  },
});
